import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import TrustIndicators from "../components/TrustIndicators";
import Testimonials from "../components/Testimonials";
import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";
import FloatingChat from "../components/FloatingChat";
import StarsBackground from "../components/StarsBackground";
import Gemstones from "../components/Gemstones";

const LandingPage = () => {
  return (
    <div
      className="relative min-h-screen bg-[#0F172A] overflow-hidden"
      data-testid="landing-page"
    >
      <StarsBackground />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Gemstones />
        <TrustIndicators />
        <Testimonials />
        <ContactForm />
      </main>
      <Footer />
      <FloatingChat />
    </div>
  );
};

export default LandingPage;
